/**
 * 역할 2개 — 운영자와 사용자(브랜드 소속 계정) (260915-access-roles · 261013-account-brand-membership 이 agency 를 지웠다).
 * 역할은 테이블 행이 아니라 값이다. seed 로 만든 행의 id 를 참조하지 않기 위해서다 (selfad D179.5).
 * 브랜드 안의 권한(소유자·관리자)은 역할이 아니라 **소속**의 값이다(`BRAND_ROLES`, api/auth.ts)
 */
export const ROLES = ['admin', 'member'] as const;
export type Role = (typeof ROLES)[number];
